import { Model as t } from "../../../model.js";
class r extends t {
  constructor(s) {
    super(), this.status = s.status, this.measurementId = s.measurementId;
  }
}
export {
  r as GoogleAnalyticsPlatformModel
};
//# sourceMappingURL=googleAnalyticsPlatform.model.js.map
